import { apiAuth } from './index';

/**
 * Response: [{
 *  status: bool(true: final submit, false)
 *  itemList: [{
 *    foodItemId: string
 *    quantity: string
 *  }]
 * }]
 */
export const fetchCart = async (dayId) => {
	try {
		const { data } = await apiAuth.get(`company/menuCart?dayId=${dayId}`);
		return data;
	} catch (e) {
		throw e;
	}
};
